export default {
  title: 'Популярные направления',
  subtitle: '{citiesCount} {cities} в {countriesCount} {countries}',
  cities: 'городов | город | города | городов',
  countries: 'странах | стране | странах | странах',
  excursions: '{n} экскурсий | {n} экскурсия | {n} экскурсии | {n} экскурсий',
} as const;
